// AUTO-EXTRACTED from SourceSecurity.com via Claude Sonnet 4.6 + Playwright MCP
// Generated: 2026-05-16
// Specs parsed from public product spec sheets; no values invented.
// All entries marked verified: false — reviewer must spot-check before promotion.

import type { EquipmentCatalogEntry } from '../equipmentCatalogEntry';

export const SS_OUTDOOR_SIRENS: EquipmentCatalogEntry[] = [
  {
    id: "ss-climax-technology-bx-15",
    manufacturer: "Climax Technology",
    model: "BX-15",
    category: "outdoor-siren",
    tagline: "Climax Technology BX-15 external bell box",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-bx-15-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"acoustic":"piezo"},
  },
  {
    id: "ss-climax-technology-bx-7-bx-8",
    manufacturer: "Climax Technology",
    model: "BX-7/BX-8",
    category: "outdoor-siren",
    tagline: "Climax Technology BX-7/BX-8 external bell box",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-bx-7-bx-8-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"acoustic":"piezo"},
  },
];
